<template>
    <div class="summary">
        <h2 class="title">Zusammenfassung</h2>
        <form @submit.prevent="onSubmit" class="form">
            <div class="summary-block mb-3 pb-3" v-for="(block, b) in summary_blocks" :key="b">
                <div class="summary-block__header d-flex justify-content-between">
                    <h3 class="title">
                        {{ block.title }}
                    </h3>
                    <a @click.prevent="gotoPath(block.route)" class="link" v-if="!block.hideEditButton">Ändern</a>
                </div>
                <div class="summary-block__content">
                    <div v-if="block.text" v-html="block.text"></div>
                </div>
            </div>

            <div class="summary-block mb-3 pb-3">
                <div class="summary-block__header">
                    <h3 class="title">Gesamtbetrag</h3>
                </div>
                <div class="summary-block__content">
                    <div class="d-flex justify-content-between">
                        <span>Netto</span><span>{{ totals.netto | number_format }}</span>
                    </div>
                    <template v-for="(vat, v) in totals.vat">
                        <div v-if="vat.sum > 0" class="d-flex justify-content-between">
                            <span>MwSt {{ v }}%</span> <span>{{ vat.sum | number_format }}</span>
                        </div>
                    </template>
                    <div class="d-flex justify-content-between">
                        <strong>Gesamtbetrag</strong>
                        <strong>{{ totals.brutto | number_format }}</strong>
                    </div>
                </div>
            </div>

            <div class="summary-block mb-3 border-0">
                <div class="summary-block__header">
                    <h3 class="title">Bemerkungen</h3>
                </div>
                <div class="summary-block__content">
                    <textarea v-model="additional_info" class="form-control" rows="5" />
                </div>
            </div>


            <Button type="submit" class="mb-2 mt-4" v-if="!savingOrder">Kostenpflichtig bestellen</Button>
            <Button class="mb-4 outline" @obClick="getOfferPdf" v-if="!savingOrder" >Anfrage senden / Angebot erhalten</Button>
        </form>
    </div>
</template>
<script>
    import Button from '../components/ux/Button.vue';
    import { mapActions, mapGetters } from 'vuex';
    import router from '../router';
    export default {
        name: "Summary",
        components: { Button },
        computed: {
            ...mapGetters("orders", [
                "fetching",
                "fetchingErrorCode",
                "fetchingError",
                "location", "paymentMethods", "totalTravelCost", "invoiceAddress", "current_articles", "subCategories", "totals", "date", "baseData", "savingOrder", "pdf_url", "jobs_hash", "job",
                "auth"
            ]),
            formIsValid() {
                return true;
            },
            additional_info: {
                get() {
                    return this.baseData.additional_info;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        additional_info: value
                    });
                },
            },
            payment_method: {
                get() {
                    const method = this.paymentMethods.filter(p => p.selected);
                    if (method.length > 0) {
                        return method[0].name;
                    }
                    return false;
                }
            },
            summary_blocks: {
                get() {
                    const date_hr = this.date.starting_date_human;
                    const invoice_address = !this.invoiceAddress.same_as_jobs_address ? `${this.baseData.clients_contacts_name} <br />${this.invoiceAddress.street}<br />${this.invoiceAddress.zip} ${this.invoiceAddress.city}` : false;
                    const date_text = this.date.is_flexible ? 'Termin ist flexibel' : `${date_hr}`;
                    // const date_text = this.date.is_flexible ? 'Termin ist flexibel' : `${date_hr} ${this.date.starting_time} Uhr`;
                    const blocks = [
                        {
                            title: "Artikel",
                            text: ``,
                            route: { name: 'Articles', step: 2}
                        },
                        {
                            title: "Auftragsort",
                            text: `${this.location.street}<br />${this.location.zip} ${this.location.city}`,
                            route: { name: 'Address', step: 3 }
                        },
                        {
                            title: "Auftragsdatum",
                            text: date_text,
                            route: { name: 'Address', step: 3 }
                        },
                        {
                            title: "Rechnungsadresse",
                            text: invoice_address || 'Identisch mit Auftragsort',
                            route: { name: 'Signin', step: 4 },
                            hideEditButton: this.auth.authenticated
                        },
                        // {
                        //     title: "Zahlungsart",
                        //     text: this.payment_method,
                        //     route: { name: 'Address', step: 3 }
                        // }
                    ];
                    this.current_articles.forEach(article => {
                        const article_is_long = article.articles_text.length > 100;
                        const article_text_class = article_is_long ? 'article__text article__text--long' : 'article__text';
                        blocks[0].text += `
                        <div class="row mb-3 article">
                            <div class="col-3 pe-0">
                                <div class="article__img d-none d-md-block" style="background-image: url(${article.thumbnail})"></div>
                                <img src="${article.thumbnail}" style="max-width: 100%;" class="d-md-none" />
                            </div>
                            <div class="col-9">
                                <div>
                                    <span class="article__title">${article.articles_category_name}</span>
                                    <span class="article__subtitle">${article.articles_name_short}</span>
                                </div>
                                <div>
                                    <strong>${this.$options.filters.number_format(article.articles_selling_price)}</strong>
                                </div>
                                <div class="${article_text_class}" style="font-size: 14px; line-height 20px;">
                                    <div class="article__text-short d-block">
                                        ${this.$options.filters.nl2br(article.articles_text.slice(0, 100))}
                                        ... <a href="#" class="js-article-toggle">mehr lesen</a>
                                    </div>
                                    <div class="article__text-full d-none">
                                        ${this.$options.filters.nl2br(article.articles_text)}
                                    </div>
                                    <hr />
                                </div>
                            </div>
                        </div>`;
                    });
                    if (this.totalTravelCost) {
                        blocks[0].text += `<div class="row mb-3">
                        <div class="col-9 offset-3">
                        <div class="d-flex justify-content-between">
                            <div>Fahrtkosten</div>
                            <div class="text-end d-flex flex-column">
                                ${this.$options.filters.number_format(this.totalTravelCost)}
                                <small style="line-height: 1">brutto: ${this.$options.filters.number_format(this.totalTravelCost*1.19)}</small>
                            </div>
                        </div>
                        </div></div>`;
                    }
                    return blocks;
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            ...mapActions("orders", ["saveOrder", "saveOrCreateClient", "generatePdf"]),
            init() {
                this.articleToggle();
                this.$store.commit('orders/saveOrderSuccess', {jobs_hash: ''});
            },
            gotoPath(route) {
                router.push(route.name);
                this.$store.dispatch("orders/navigate", route.step);
            },
            articleToggle() {
                const article_texts = document.querySelectorAll('.article__text');
                if (!article_texts) {
                    setTimeout(() => {
                        this.articleToggle();
                    }, 500);
                }

                const longtexts = Object.entries(article_texts).filter(el => el[1].classList.contains('article__text--long'));
                longtexts.forEach(text => {
                    const trigger = text[1].querySelector('.js-article-toggle');
                    trigger.addEventListener('click', e => {
                        e.preventDefault();
                        const shorttext = text[1].querySelector('.article__text-short');
                        const fulltext = text[1].querySelector('.article__text-full');
                        shorttext.classList.toggle('d-none')
                        shorttext.classList.toggle('d-block')
                        fulltext.classList.toggle('d-none')
                        fulltext.classList.toggle('d-block')
                    })
                })
            },
            // submit summary page
            // place oder in ob system
            // send verification stuff to client
            async onSubmit() {
                try {
                    if (this.formIsValid && !this.savingOrder) {
                        const client_data = {
                            clients_contacts_hash: this.baseData.clients_contacts_hash || null,
                            clients_hash: this.baseData.clients_hash || null,
                        }

                        if (this.auth.authenticated) {
                            const verified = !this.auth.newUser;
                            await this.saveOrder({ jobs_hash: this.jobs_hash, verified: verified }).then(() => {
                                if (this.fetchingError != "") {
                                    return false;
                                }
                                this.$options.methods.scrollTop();
                                if (verified) {
                                    this.gotoPath({ name: "Confirmation", step: 6 })
                                } else {
                                    this.gotoPath({ name: "Verify", step: 5 })
                                }
                            });
                        } else {

                            await this.saveOrCreateClient(client_data).then( async () => {
                                if (this.fetchingError != "") {
                                    return false;
                                }
                                await this.saveOrder({ jobs_hash: this.jobs_hash }).then(() => {
                                    if (this.fetchingError != "") {
                                        return false;
                                    }
                                    this.$options.methods.scrollTop();
                                    this.gotoPath({ name: "Verify", step: 5 })
                                });
                            })
                        }
                    }
                } catch (error) {
                    console.table(error);
                }
            },
            // submit summary page
            // place order in ob system
            // send offer pdf to client view (download)
            async getOfferPdf() {
                try {
                    if (this.formIsValid && !this.savingOrder) {
                        const client_data = {
                            clients_contacts_hash: this.baseData.clients_contacts_hash || null,
                            clients_hash: this.baseData.clients_hash || null,
                        }

                        // user ist bereits eingeloggt
                        if(this.auth.authenticated) {
                            await this.saveOrder({ jobs_hash: this.jobs_hash, first_offer: true })
                                .then(async () => {
                                    if (this.fetchingError != "") {
                                        return false;
                                    }
                                    await this.generatePdf().then(() => true).catch(() => { return false; })
                                        .then(() => {
                                            if (this.fetchingError != "") {
                                                return false;
                                            }
                                            const link = document.createElement('a');
                                            link.href = this.pdf_url;
                                            link.target = '_blank';
                                            link.download = "Angebot.pdf";
                                            link.click();
                                        });
                                });
                        } else {

                            await this.saveOrCreateClient(client_data).then(async () => {
                                if (this.fetchingError != "") {
                                    return false;
                                }
                                await this.saveOrder({ jobs_hash: this.jobs_hash, first_offer: true })
                                    .then(async () => {
                                        if (this.fetchingError != "") {
                                            return false;
                                        }
                                        await this.generatePdf().then(() => true).catch(() => { return false; })
                                            .then(() => {
                                                if (this.fetchingError != "") {
                                                    return false;
                                                }
                                                const link = document.createElement('a');
                                                link.href = this.pdf_url;
                                                link.target = '_blank';
                                                link.download = "Angebot.pdf";
                                                link.click();
                                            });
                                    });
                            }).catch(e => {
                                console.log(e);
                            });
                        }


                    }
                } catch (error) {
                    console.table(error);
                }
            }
        }
    }
</script>

<style lang="scss">
    .summary-block {
        border-bottom: 1px solid $border-color;
        color: $basic-font-color;
        font-size: 16px;
        font-weight: 500;
        line-height: 26px;

        &__header {
            .title {
                color: $basic-font-color;
                font-size: 16px;
                font-weight: 500;
            }

            .link {
                color: $primary-color;
                text-decoration: none;
                font-weight: 300;
            }

        }
        &__content {
            color: $dark-gray;
        }
    }

    .article {

        &__title {
            display: block;
            margin-bottom: 3px;
            font-weight: 500;
            font-size: 20px;
            line-height: 26px;
        }

        &__subtitle {
            display: block;
            font-weight: 500;
            font-size: 16px;
        }

        &__img {
            height: 150px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
        }

        strong {
            font-weight: 900;
        }
    }

    @media (min-width: 768px) {
        .summary {
            padding: 30px 30px 100px 30px;
            border: 1px solid $border-color;
            // margin-bottom: 100px;
        }
    }
</style>